export const TYPE_FIELDS = {
  typeToLibrary: "type to library",
  typeToPoints: "type to points",
};
